// @ts-nocheck
import { post } from "@insite/client-framework/Services/ApiService";
import { SubmitWarrantyFormApiParameter } from "@store/Framework/Store/Store/Components/WarrantyForm/Handlers/SubmitWarrantyForm";

export function postSubmitWarrantyForm(parameter: SubmitWarrantyFormApiParameter) {
    return post<SubmitWarrantyFormApiParameter, void>(`/api/v1/warranty/submit`, parameter);
}
